export const validateResponses = (responses: any[]) => {
  responses.forEach((res) => {
    if (!res.ok) {
      throw new Error('An error has occurred on updating a venue');
    }
  });
};
